<template lang="pug">
  #select
    .subbox
      img.denied-svg(src="@/assets/emptystate.svg")
      br
      span.title No project selected
      p select a project from the list to view the rfis from that project
</template>

<script>
export default {
  name: 'SelectProjectRfi'
}
</script>
<style lang="scss" scoped>
#select {
  width: 100%;
  height: calc(100vh - 110px);
  display: flex;
  margin: 10px 0 0 10px;
  background: white;
  padding: 20px 20px;
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
   .subbox {
    border: 1px solid #e4e3e3;
    width: calc(200vh - 10px);
    align-items: center;
    text-align: center;
    justify-content: center;
    flex-direction: column;
    vertical-align: middle;
    .title {
      font-weight: 600;
      font-size: 18px;
    }
  }

  img.denied-svg {
    max-width: 450px;
    margin: 80px 0px 50px 0px;
  }
}
</style>
